/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const EyesWink = ({ className }) => {
  return (
    <svg
      className={`eyes-wink ${className}`}
      fill="none"
      height="13"
      viewBox="0 0 32 13"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#FFDBB4"
        height="12.1"
        transform="translate(0.606445 0.375)"
        width="30.8226"
      />

      <ellipse
        className="ellipse-33"
        cx="8.86215"
        cy="6.42441"
        fill="black"
        fillOpacity="0.6"
        rx="1.65121"
        ry="1.65"
      />

      <path
        className="path"
        clipRule="evenodd"
        d="M20.0379 7.23828C20.4719 6.16073 21.5624 5.3544 22.8893 5.26169C24.2115 5.1693 25.4 5.81122 25.9821 6.81184C26.155 7.10908 25.9572 7.37604 25.7269 7.20456C25.0135 6.6735 24.0327 6.37925 22.9727 6.45332C21.9458 6.52507 21.0407 6.92877 20.4101 7.52221C20.1796 7.73919 19.9109 7.55344 20.0379 7.23828Z"
        fill="black"
        fillOpacity="0.6"
        fillRule="evenodd"
      />
    </svg>
  );
};
